import styled, { css, ThemeContext } from 'styled-components';
import { lighten, darken, desaturate } from 'polished';
import Select from 'react-select/async-creatable';

import { fadeIn } from 'styles/animation';

export const Container = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0px;
  width: 100%;

  ${props =>
    props.error &&
    css`
      height: 59px;
      max-height: 59px;
    `}
  &:last-of-type {
    margin: 0px;
  }

  /* ICON ERROR */
  i {
    text-decoration: none;
    font-style: normal;

    position: absolute;
    align-self: flex-end;
    padding: 0.4rem 0.6rem 0rem 0.6rem;

    svg {
      font-size: 0.875rem;
      stroke-width: 3px;
      /* opacity: 0.9; */
      /* color: ${props => props.theme.fontColor}; */

      -webkit-transition: all 0.15s ease 0s;
      transition: all 0.15s ease 0s;

      &:hover {
        opacity: 1;
      }
    }
  }
`;

export const SelectComponent = styled(Select)`
  min-width: 200px;
  width: 100%;
  min-height: 38px;
  margin-bottom: 20px;
  > div {
    ${props =>
      props.fill
        ? css`
            background: transparent;
          `
        : css`
            background: ${props =>
              props.theme.name === 'dark'
                ? lighten(0.05, props.theme.cardBackgroud)
                : darken(0.01, props.theme.cardBackgroud)};
          `}

    border: 1px solid ${props => props.theme.componentborder};
    ${({ error }) =>
      error === 'true' &&
      css`
        border-color: ${props => props.theme.error};
      `}

    &:focus,&:hover {
      border: 1px solid
        ${props => desaturate(0.5, props.theme.button.primary.in)};
    }

    ${({ error }) =>
      error &&
      css`
        border-color: ${props => props.theme.error};

        &:focus,
        &:hover {
          border-color: ${props => props.theme.error};
        }
      `}

    &:nth-child(1) {
      div {
        /* opacity: 0.9; */
        color: ${props => props.theme.fontColor};
      }

      &:focus-within {
        color: red;
      }
    }

    /* MENU OPENED*/
    &:nth-child(3) {
      background-color: #fff;
      color: #1d253b;
      background-color: #fff;
      border-radius: 4px;

      background-clip: padding-box;
      border-width: 0 solid rgba(34, 42, 66, 0.15);
      box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),
        0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);

      animation: ${fadeIn} 0.1s ease-in;
      display: block;

      &:hover {
        border: 0;
      }

      &::before {
        display: inline-block;
        position: absolute;
        width: 0;
        height: 0;
        vertical-align: middle;
        content: '';
        color: #fff;

        ${props =>
          props.menuPlacement === 'top'
            ? css`
                top: 100%;
                left: auto;
                bottom: -5px;
                right: 10px;
                border-top: 0.4em solid;
                border-right: 0.4em solid transparent;
                border-left: 0.4em solid transparent;
              `
            : css`
                top: -5px;
                left: auto;
                right: 10px;

                border-bottom: 0.4em solid;
                border-right: 0.4em solid transparent;
                border-left: 0.4em solid transparent;
              `}
      }

      > div {
        > div {
          -webkit-transition: all 0.15s linear;
          transition: all 0.15s linear;
          &:hover {
            /* background-color: hsla(0, 0%, 87.1%, 0.3); */
          }
        }
      }
    }
  }

  svg {
    /* opacity: 0.8; */
    /* color: ${props => props.theme.lightFontColor}; */
  }
`;
export const customStyles = theme => ({
  placeholder: (provided, state) => ({
    ...provided,
    width: `max-content !important`,
    fontSize: '0.8rem',
    fontWeight: 300,
    opacity: 0.6,
    color: theme.fontColor,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isDisabled
      ? null
      : state.isSelected
      ? null
      : state.isFocused
      ? 'hsla(0, 0%, 87.1%, 0.3)'
      : null,
    color: state.isDisabled
      ? 'hsla(0, 0%, 0%, 0.3)'
      : state.isSelected
      ? theme.select.selected
      : '#1d253b',
    fontWeight: state.isSelected ? '600' : '400',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
  }),
  singleValue: (base, state) => ({
    ...base,
    padding: '0 8px',
    borderRadius: 5,
    background: state.data.__isNew__ ? theme.select.new : theme.select.selected,
    color: 'white',
    display: 'flex',
  }),
  multiValueLabel: base => {
    return {
      ...base,
      color: theme.lightFontColor,
    };
  },
  multiValueRemove: (base, state) => {
    return {
      ...base,
      display: state.isDisabled ? 'none' : 'block',
      // color: ThemeContext.lightFontColor,
      ':hover': {
        backgroundColor: '#fff',
        color: theme.select.selected,
      },
    };
  },
  valueContainer: (base, state) => {
    return {
      ...base,
      maxHeight: '100px',
    };
  },
  multiValue: (base, state) => {
    return {
      ...base,
      padding: '0 8px',
      borderRadius: 5,
      background: state.data.__isNew__
        ? theme.select.new
        : theme.select.selected,
      alignItems: 'center',
      display: 'flex',
    };
  },
  control: base => ({
    ...base,
    cursor: 'default',
  }),
  input: base => ({
    ...base,
    color: theme.fontColor,
  }),
  indicatorSeparator: base => ({
    backgroundColor: 'transparent',
  }),
  loadingIndicator: base => ({
    display: 'flex',
    padding: 4,
    span: {
      height: '0.5em',
      width: '0.5em',
      marginRight: -5,
    },
  }),
});

export const menuHeaderStyle = {
  padding: '8px 12px',
  background: '#fff',
  color: 'hsla(0, 0%, 0%, 0.3)',
};

export const ErrorMessage = styled.span`
  margin-top: 1.5px;
  align-self: flex-start;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  font-size: 0.75rem;
  color: ${props => props.theme.error};
`;

export const OptionContent = styled.div`
  display: flex;
  padding: 2px 8px 2px 8px;
`;

export const OptionComercial = styled.div`
  display: flex;
  align-items: center;
  span {
    color: grey;
    margin-left: 5px;
    font-style: oblique;
  }
`;

export const Flag = styled.span`
  position: relative;
  width: 5px;
  height: 40px;
  background: ${props => (props.type ? props.theme.flag[props.type] : 'none')};
`;
